import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({ baseURL: API_BASE });

// Attach JWT token to all requests
api.interceptors.request.use(config => {
  const token = localStorage.getItem('ragvi_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ragvi_token');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

// ---- Public API calls ----
export const fetchHero = () => api.get('/hero');
export const fetchAbout = () => api.get('/about');
export const fetchPortfolio = (params) => api.get('/portfolio', { params });
export const fetchPortfolioById = (id) => api.get(`/portfolio/${id}`);
export const fetchDesigns = (params) => api.get('/designs', { params });
export const fetchServices = () => api.get('/services');
export const fetchHowWeWork = () => api.get('/how-we-work');
export const submitContact = (data) => api.post('/contacts', data);
export const submitLead = (data) => api.post('/leads', data);

// ---- Admin API calls ----
export const adminLogin = (data) => api.post('/auth/login', data);
export const getMe = () => api.get('/auth/me');
export const getDashboardStats = () => api.get('/dashboard/stats');

export const updateHero = (data) => api.put('/hero', data);
export const updateAbout = (data) => api.put('/about', data);

export const createPortfolio = (data) => api.post('/portfolio', data);
export const updatePortfolio = (id, data) => api.put(`/portfolio/${id}`, data);
export const deletePortfolio = (id) => api.delete(`/portfolio/${id}`);

export const createDesign = (data) => api.post('/designs', data);
export const updateDesign = (id, data) => api.put(`/designs/${id}`, data);
export const deleteDesign = (id) => api.delete(`/designs/${id}`);

export const createService = (data) => api.post('/services', data);
export const updateService = (id, data) => api.put(`/services/${id}`, data);
export const deleteService = (id) => api.delete(`/services/${id}`);

export const createStep = (data) => api.post('/how-we-work', data);
export const updateStep = (id, data) => api.put(`/how-we-work/${id}`, data);
export const deleteStep = (id) => api.delete(`/how-we-work/${id}`);

export const getContacts = (params) => api.get('/contacts', { params });
export const updateContact = (id, data) => api.put(`/contacts/${id}`, data);
export const deleteContact = (id) => api.delete(`/contacts/${id}`);
export const getLeads = (params) => api.get('/leads', { params });
export const updateLead = (id, data) => api.put(`/leads/${id}`, data);
export const deleteLead = (id) => api.delete(`/leads/${id}`);

export const uploadImage = (section, formData) =>
  api.post(`/upload/${section}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const uploadMultipleImages = (section, formData) =>
  api.post(`/upload/${section}/multiple`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export default api;
